import {
  lshGETAUTH,
  _IsLink,
  _ToTitleCase,
  EInputOrderPaymentType,
  IlogisticsTypeId,
} from './core';
import {graphqlRequestHandler} from './core';
import {
  ICreateInvoiceResponse,
  ICreateQuoteResponse,
  IFarmInputCreditNote,
  IFarmInputCreditNoteLineItem,
  IFarmInputCreditNoteLineItemInput,
  IFarmInputInvoice,
  IFarmInputQuote,
  IFarmInputQuoteLineItem,
  IGenericResponse,
  IInputMessage,
  IInputQuoteAddress,
  IInputQuoteProductInput,
  IInvoiceBundle,
  IInvoiceSupportingDocumentInput,
  IOrderReplacement,
  IQuoteMessage,
  IQuoteSupportingDocumentInput,
  ISupportingDocument,
  ISupplierUserProfile,
} from 'constants/interfaces';

export type ReplaceProformaInvoiceLineItemInput = {
  id?: string;
  stockCode: string;
  price: number;
  quantity: number;
};

export type ReplaceProformaInvoiceProductsResult = {
  id: number;
  total: number;
  orders: Array<{
    id: string;
    product: {id: string; stockCode?: string};
    quantity: number;
    price: number;
  }>;
};

export type ConvertProformaToInvoiceResult = {
  id: number;
  total: number;
  documentUrl?: string;
};

export async function apiGetDepotOrders(
  limit?: number,
  farmerId?: number | string,
): Promise<IFarmInputInvoice[]> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {limit, farmerId};
    return new Promise((resolve, reject) => {
      const query = `
                query variables($limit: Int, $farmerId: ID){
                    farmInputInvoicesForSupplier(limit: $limit, farmerId: $farmerId){
                        id
                        invoiceNumber
                        insertedDate
                        updatedDate
                        isPaid
                        latitude
                        longitude
                        address
                        total
                        outstanding
                        deliveryType
                        documentUrl
                        proformaInvoiceUrl
                        state
                        vatExempt
                        orders{
                            id
                            quantity
                            price
                            isDelivered
                            dueDate
                            logisticsType
                            logisticsTypeName
                            product{
                                id
                                name
                                category
                                stockCode
                                size
                                price
                                measurement
                                grade
                                activeIngredient
                                tradeName
                                image
                            }
                        }
                        farmer{
                            id
                            name
                            surname
                            email
                            phone
                            image
                            address
                            farm{
                                id
                                name
                                sizeHectares
                                type
                                turnover
                                numberOfEmployees
                                province
                                latLong
                            }
                        }
                        orderStatus{
                            index
                            status
                            description
                        }
                        depot{
                            name
                        }
                    }
                }`;
      graphqlRequestHandler(
        'farmInputInvoicesForSupplier',
        query,
        variables,
        headers,
      )
        .then((invoices: IFarmInputInvoice[]) => {
          invoices.forEach((invoice) => {
            invoice.currOrderStatus =
              invoice.orderStatus.find(
                (item) => item.status === 'IN_PROGRESS',
              ) || invoice.orderStatus[0];
            if (!_IsLink(invoice.farmer?.image)) {
              invoice.farmer.image = '';
            }
          });
          resolve(invoices);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiGetDepotOrder(id: number): Promise<IFarmInputInvoice> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {id};
    return new Promise((resolve, reject) => {
      const query = `
                query variables($id: ID!){
                    farmInputInvoice(id: $id){
                        id
                        invoiceNumber
                        insertedDate
                        updatedDate
                        isPaid
                        latitude
                        longitude
                        address
                        total
                        outstanding
                        deliveryType
                        documentUrl
                        logisticsCost
                        vatExempt
                        state
                        proformaInvoiceUrl
                        orders{
                            id
                            quantity
                            price
                            isDelivered
                            dueDate
                            logisticsType
                            logisticsTypeName
                            product{
                                id
                                name
                                category
                                stockCode
                                size
                                price
                                measurement
                                grade
                                activeIngredient
                                tradeName
                                image
                            }
                        }
                        farmer{
                            id
                            name
                            surname
                            email
                            phone
                            image
                            address
                            farm{
                                id
                                name
                                sizeHectares
                                type
                                turnover
                                numberOfEmployees
                                province
                                latLong
                            }
                        }
                        orderStatus{
                            index
                            status
                            description
                        }
                        depot{
                            name
                        }
                    }
                }`;
      graphqlRequestHandler('farmInputInvoice', query, variables, headers)
        .then((invoice: IFarmInputInvoice) => {
          invoice.currOrderStatus =
            invoice.orderStatus.find((item) => item.status === 'IN_PROGRESS') ||
            invoice.orderStatus[0];
          if (!_IsLink(invoice.farmer?.image)) {
            invoice.farmer.image = '';
          }
          resolve(invoice);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiGetProformaInvoicesForSupplier(
  limit?: number,
  farmerId?: number | string,
): Promise<IFarmInputInvoice[]> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {limit, farmerId};
    return new Promise((resolve, reject) => {
      const query = `
                query variables($limit: Int, $farmerId: ID){
                    farmInputInvoicesForSupplier(limit: $limit, farmerId: $farmerId){
                        id
                        invoiceNumber
                        insertedDate
                        updatedDate
                        isPaid
                        latitude
                        longitude
                        address
                        total
                        outstanding
                        deliveryType
                        documentUrl
                        proformaInvoiceUrl
                        state
                        vatExempt
                        orders{
                            id
                            quantity
                            price
                            isDelivered
                            dueDate
                            logisticsType
                            logisticsTypeName
                            product{
                                id
                                name
                                category
                                stockCode
                                size
                                price
                                measurement
                                grade
                                activeIngredient
                                tradeName
                                image
                            }
                        }
                        farmer{
                            id
                            name
                            surname
                            email
                            phone
                            image
                            address
                            farm{
                                id
                                name
                                sizeHectares
                                type
                                turnover
                                numberOfEmployees
                                province
                                latLong
                            }
                        }
                        orderStatus{
                            index
                            status
                            description
                        }
                        depot{
                            name
                        }
                    }
                }`;
      graphqlRequestHandler(
        'farmInputInvoicesForSupplier',
        query,
        variables,
        headers,
      )
        .then((invoices: IFarmInputInvoice[]) => {
          invoices.forEach((invoice) => {
            invoice.currOrderStatus =
              invoice.orderStatus?.find(
                (item) => item.status === 'IN_PROGRESS',
              ) || invoice.orderStatus?.[0];
            if (invoice.farmer && !_IsLink(invoice.farmer?.image)) {
              invoice.farmer.image = '';
            }
          });
          resolve(invoices);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiReplaceProformaInvoiceProducts(
  proformaInvoiceId: string | number,
  products: ReplaceProformaInvoiceLineItemInput[],
): Promise<ReplaceProformaInvoiceProductsResult> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {proformaInvoiceId: String(proformaInvoiceId), products};
    return new Promise((resolve, reject) => {
      const mutation = `
        mutation ReplaceProformaInvoiceProducts(
          $proformaInvoiceId: ID!,
          $products: [ReplaceProformaInvoiceLineItemInput!]!
        ) {
          replaceProformaInvoiceProducts(
            proformaInvoiceId: $proformaInvoiceId,
            products: $products
          ) {
            id
            total
            orders {
              id
              product {
                id
                stockCode
              }
              quantity
              price
            }
          }
        }
      `;
      graphqlRequestHandler(
        'replaceProformaInvoiceProducts',
        mutation,
        variables,
        headers,
      )
        .then((result: ReplaceProformaInvoiceProductsResult) => resolve(result))
        .catch(reject);
    });
  });
}

export async function apiAddProformaInvoiceProduct(
  proformaInvoiceId: string | number,
  product: Omit<ReplaceProformaInvoiceLineItemInput, 'id'>,
): Promise<ReplaceProformaInvoiceProductsResult> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {
      proformaInvoiceId: String(proformaInvoiceId),
      product: {
        stockCode: product.stockCode,
        price: product.price,
        quantity: product.quantity,
      },
    };
    return new Promise((resolve, reject) => {
      const mutation = `
        mutation AddProformaProduct(
          $proformaInvoiceId: ID!,
          $product: ReplaceProformaInvoiceLineItemInput!
        ) {
          addProformaInvoiceProduct(
            proformaInvoiceId: $proformaInvoiceId,
            product: $product
          ) {
            id
            total
            orders {
              id
              product {
                id
                stockCode
              }
              quantity
              price
            }
          }
        }
      `;
      graphqlRequestHandler(
        'addProformaInvoiceProduct',
        mutation,
        variables,
        headers,
      )
        .then((result: ReplaceProformaInvoiceProductsResult) => resolve(result))
        .catch(reject);
    });
  });
}

export async function apiRemoveProformaInvoiceProduct(
  proformaInvoiceId: string | number,
  stockCode: string,
): Promise<ReplaceProformaInvoiceProductsResult> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {
      proformaInvoiceId: String(proformaInvoiceId),
      stockCode,
    };
    return new Promise((resolve, reject) => {
      const mutation = `
        mutation RemoveProformaProduct(
          $proformaInvoiceId: ID!,
          $stockCode: String!
        ) {
          removeProformaInvoiceProduct(
            proformaInvoiceId: $proformaInvoiceId,
            stockCode: $stockCode
          ) {
            id
            total
            orders {
              id
              product {
                id
                stockCode
              }
              quantity
              price
            }
          }
        }
      `;
      graphqlRequestHandler(
        'removeProformaInvoiceProduct',
        mutation,
        variables,
        headers,
      )
        .then((result: ReplaceProformaInvoiceProductsResult) => resolve(result))
        .catch(reject);
    });
  });
}

export async function apiConvertProformaToInvoice(
  proformaInvoiceId: string | number,
): Promise<ConvertProformaToInvoiceResult> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {proformaInvoiceId: String(proformaInvoiceId)};
    return new Promise((resolve, reject) => {
      const mutation = `
        mutation ConvertProformaToInvoice($proformaInvoiceId: ID!) {
          convertProformaToInvoice(proformaInvoiceId: $proformaInvoiceId) {
            id
            total
            documentUrl
          }
        }
      `;
      graphqlRequestHandler(
        'convertProformaToInvoice',
        mutation,
        variables,
        headers,
      )
        .then((result: ConvertProformaToInvoiceResult) => resolve(result))
        .catch(reject);
    });
  });
}

export async function apiGetDepotQuotes(
  limit?: number,
  farmerId?: number | string,
): Promise<IFarmInputQuote[]> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables: {
      limit?: number;
      farmerId?: number | string;
    } = {};

    if (typeof limit === 'number' && limit > 0) {
      variables.limit = limit;
    }
    if (farmerId !== undefined) {
      variables.farmerId = farmerId;
    }
    return new Promise((resolve, reject) => {
      const query = `
          query variables($limit: Int, $farmerId: ID){
              farmInputQuotationsForSupplier(limit: $limit, farmerId: $farmerId){
                  id
                  quoteNumber
                  insertedOn
                  updateDate
                  latitude
                  longitude
                  address
                  total
                  isForDelivery
                  state
                  isExpired
                  lineItems{
                      id
                      retailPrice
                      price
                      originalQuantity
                      quantity
                      product{
                          id
                          name
                          category
                          mainCategoryId
                          subCategoryId
                          subCategoryName
                          stockCode
                          size
                          price
                          measurement
                          grade
                          activeIngredient
                          tradeName
                          image
                      }
                  }
                  farmer{
                      id
                      userId
                      name
                      surname
                      email
                      phone
                      image
                      address
                      farm{
                          id
                          name
                          sizeHectares
                          type
                          turnover
                          numberOfEmployees
                          province
                          latLong
                      }
                  }
                  depot{
                      name
                  }
              }
          }`;
      graphqlRequestHandler(
        'farmInputQuotationsForSupplier',
        query,
        variables,
        headers,
      )
        .then((quotes: IFarmInputQuote[]) => {
          const mappedQuotes = quotes.map(mapQuoteResponse);
          resolve(mappedQuotes);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiGetDepotQuote(
  quoteId: number,
): Promise<IFarmInputQuote> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {quoteId};
    return new Promise((resolve, reject) => {
      const query = `
          query variable($quoteId: ID!){
              farmInputQuotationForSupplier(quotationId: $quoteId){
                  id
                  quoteNumber
                  insertedOn
                  updateDate
                  latitude
                  longitude
                  address
                  total
                  isForDelivery
                  state
                  isExpired
                  logisticsCost
                  contactPersonName
                  contactPersonPhoneNumber
                  deliveryInstructions
                  lineItems{
                      id
                      retailPrice
                      price
                      costPrice
                      originalQuantity
                      quantity
                      product{
                          id
                          name
                          category
                          mainCategoryId
                          subCategoryId
                          subCategoryName
                          stockCode
                          size
                          price
                          measurement
                          grade
                          activeIngredient
                          tradeName
                          image
                      }
                  }
                  farmer{
                      id
                      userId
                      name
                      surname
                      email
                      phone
                      image
                      address
                      farm{
                          id
                          name
                          sizeHectares
                          type
                          turnover
                          numberOfEmployees
                          province
                          latLong
                      }
                  }
                  depot{
                      id
                      name
                      address1
                      address2
                      address3
                      address4
                      address5
                      latitude
                      longitude
                  }
              }
          }`;
      graphqlRequestHandler(
        'farmInputQuotationForSupplier',
        query,
        variables,
        headers,
      )
        .then((quote: IFarmInputQuote) => {
          resolve(mapQuoteResponse(quote));
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

const mapQuoteResponse = (quote: any): IFarmInputQuote => {
  if (!_IsLink(quote.farmer?.image)) {
    quote.farmer.image = '';
  }
  return {
    ...quote,
    id: parseInt(quote.id),
    formattedState: _ToTitleCase(quote.state.replaceAll('_', ' ')),
    deliveryType: quote.isForDelivery ? 'Delivery' : 'Collection',
  };
};

export async function apiUPDATEQUOTELINEITEM(
  lineItem: IFarmInputQuoteLineItem,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {
      productLineId: lineItem.id,
      quotedPrice: lineItem.price,
      quotedQuantity: lineItem.quantity,
    };
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $productLineId: ID!,
            $quotedPrice: Float,
            $quotedQuantity: Float
          ){
              updateFarmInputQuoteLineItem (
                productLineId: $productLineId,
                quotedPrice: $quotedPrice,
                quotedQuantity: $quotedQuantity
              ){
                  success
                  message
              }
          }`;
      graphqlRequestHandler(
        'updateFarmInputQuoteLineItem',
        query,
        variables,
        headers,
      )
        .then((response: IGenericResponse) => {
          if (!response.success) throw new Error(response.message);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiDELETEQUOTELINEITEM(
  lineItemId: number,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {
      productLineId: lineItemId,
      delete: true,
    };
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $productLineId: ID!,
            $delete: Boolean,
          ){
              updateFarmInputQuoteLineItem (
                productLineId: $productLineId,
                delete: $delete,
              ){
                  success
                  message
              }
          }`;
      graphqlRequestHandler(
        'updateFarmInputQuoteLineItem',
        query,
        variables,
        headers,
      )
        .then((response: IGenericResponse) => {
          if (!response.success) throw new Error(response.message);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiADDQUOTELINEITEM(
  quoteId: number,
  lineItem: IFarmInputQuoteLineItem,
): Promise<IFarmInputQuote> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {
      quoteId,
      lineItem: {
        stockCode: lineItem.product.stockCode,
        price: lineItem.price,
        quantity: lineItem.quantity,
      },
    };
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $quoteId: ID!,
            $lineItem: FarmInputQuoteLineItemInput!,
          ){
              supplierAddFarmQuoteProductLine (
                quoteId: $quoteId,
                lineItem: $lineItem,
              ){
                  id
                  quoteNumber
              }
          }`;
      graphqlRequestHandler(
        'supplierAddFarmQuoteProductLine',
        query,
        variables,
        headers,
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiSUBMITQUOTE(
  quoteId: number,
): Promise<IFarmInputQuote> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {quoteId};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($quoteId: ID!){
            supplierConfirmFarmQuoteChanges (
              quoteId: $quoteId,
            ){
              id
              quoteNumber
            }
          }`;
      graphqlRequestHandler(
        'supplierConfirmFarmQuoteChanges',
        query,
        variables,
        headers,
      )
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

/**
 * Api to get messages for specific order
 * @param {number} invoiceId
 * @return {Promise}
 */
export async function apiGETORDERMESSAGES(
  invoiceId: number,
): Promise<IInputMessage[]> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    return new Promise((resolve, reject) => {
      const query = `
            query variables($invoiceId: ID!){
                getInputMessages(lastId: 0, invoiceIndex: $invoiceId){
                    id
                    invoiceIndex
                    mType
                    sent
                    messageRead
                    sender
                    textMessageData{
                        id
                        textMessage
                    }
                    replacementData{
                        id
                        orderId
                        previousQuantity
                        previousPrice
                        quantity
                        price
                        response
                        editable
                        previousProduct{
                            id
                            name
                            stockCode
                            category
                            image
                        }
                        replacementProduct{
                            id
                            name
                            stockCode
                            category
                            image
                        }
                    }
                }
            }`;
      const variables = {invoiceId};
      graphqlRequestHandler('getInputMessages', query, variables, headers)
        .then((messages: any[]) => {
          const mappedMessages: IInputMessage[] = messages.map((message) => ({
            id: message.id,
            invoiceId: message.invoiceIndex,
            // todo message type comes back as string. should be number
            messageType:
              message.mType === '1'
                ? 'TEXT'
                : message.mType === '2'
                ? 'IMAGE'
                : 'PRODUCT',
            date: new Date(parseInt(message.sent)),
            isRead: message.messageRead,
            senderType: message.sender === 1 ? 'FARMER' : 'SUPPLIER',
            textData: !message.textMessageData
              ? undefined
              : {
                  id: message.textMessageData.id,
                  message: message.textMessageData.textMessage,
                },
            productData: !message.replacementData
              ? undefined
              : {
                  ...message.replacementData,
                  response:
                    message.replacementData.response === 0
                      ? 'PENDING'
                      : message.replacementData.response === 1
                      ? 'ACCEPTED'
                      : 'REIMBURSEMENT',
                  previousProduct: message.replacementData.previousProduct,
                  replacementProduct:
                    message.replacementData.replacementProduct,
                },
          }));
          resolve(mappedMessages);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

/**
 * Api to send order message
 * @param {number} invoiceId
 * @param {string} message
 * @return {Promise}
 */
export async function apiSENDTEXTORDERMESSAGE(
  invoiceId: number,
  message: string,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    return new Promise((resolve, reject) => {
      const query = `
            mutation variables($invoiceId: ID!, $message: String){
                inputChat(chatInput:{
                    invoiceIndex: $invoiceId
                    textMessage: $message,
                    mType:1
                }){
                    success
                    message
                }
            }`;
      const variables = {invoiceId, message};
      graphqlRequestHandler('inputChat', query, variables, headers)
        .then((response: IGenericResponse) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

/**
 * Api to send replacement order message
 * @param {IOrderReplacement} orderReplacement
 * @return {Promise}
 */
export async function apiSENDREPLACEMENTORDERMESSAGE(
  orderReplacement: IOrderReplacement,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {
      invoiceId: orderReplacement.invoiceId,
      orderId: orderReplacement.orderId,
      replacementProduct: orderReplacement.replacementProductStockCode,
      quantity: orderReplacement.quantity,
      price: orderReplacement.price,
    };
    return new Promise((resolve, reject) => {
      const query = `
                mutation variables(
                  $invoiceId: ID!,
                  $orderId: ID!,
                  $replacementProduct: String!,
                  $quantity: Float!,
                  $price: Float!){
                    inputChat(chatInput:{
                        mType:3,
                        invoiceIndex: $invoiceId
                        replacementInfo:{
                            orderId: $orderId
                            replacementProduct: $replacementProduct,
                            quantity: $quantity,
                            price: $price
                        }
                    }){
                        success
                        message
                    }
                }
            `;
      graphqlRequestHandler('inputChat', query, variables, headers)
        .then((response: IGenericResponse) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiUpdateInputOrderPaymentStatus(
  invoiceId: number,
  isPaid: boolean,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    return new Promise((resolve, reject) => {
      const variables = {invoiceId, isPaid};
      const query = `
          mutation variables($invoiceId: ID!, $isPaid: Boolean!){
              farmInputInvoiceSaveOrderPaymentStatus(id: $invoiceId, isPaid: $isPaid){
                  id
                  isPaid
              }
          }`;
      graphqlRequestHandler(
        'farmInputInvoiceSaveOrderPaymentStatus',
        query,
        variables,
        headers,
      )
        .then(() => {
          resolve({success: true});
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

/**
 * Api to update order status
 * @param {number} invoiceId
 * @param {number} orderStatusId
 * @return {Promise}
 */
export async function apiUpdateInputOrderStatus(
  invoiceId: number,
  orderStatusId: number,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    return new Promise((resolve, reject) => {
      const variables = {invoiceId, orderStatusId};
      const query = `
                mutation variables($invoiceId: ID!, $orderStatusId: Int!){
                    farmInputInvoiceSaveOrderStatus(id: $invoiceId, orderStatusId: $orderStatusId){
                        id
                        orderStatus{
                            index
                            status
                            description
                        }
                    }
                }`;
      graphqlRequestHandler(
        'farmInputInvoiceSaveOrderStatus',
        query,
        variables,
        headers,
      )
        .then(() => {
          resolve({success: true});
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiCreateQuote(
  farmerId: number,
  products: IInputQuoteProductInput[],
  deliveryAddress?: IInputQuoteAddress,
  isVatExempt?: boolean,
  specialInstructions?: {
    contactPersonName?: string;
    contactPersonPhoneNumber?: string;
    deliveryInstructions?: string;
  },
  logisticsCost?: number,
): Promise<ICreateQuoteResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {
      farmerId,
      inputs: products,
      deliveryAddress,
      vatExempted: isVatExempt,
      specialInstructions,
      logisticsCost,
    };
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $farmerId: ID,
            $inputs: [FarmInputQuoteLineItemInput]!,
            $deliveryAddress: DeliveryAddressInput,
            $vatExempted: Boolean,
            $specialInstructions: BuyInputsSpecialInstructions,
            $logisticsCost: Float,
          ){
              createFarmInputQuote(
                farmerId: $farmerId,
                inputs: $inputs,
                deliveryAddress: $deliveryAddress,
                vatExempted: $vatExempted,
                supplierIsCreating: true,
                specialInstructions: $specialInstructions
                logisticsCost: $logisticsCost
              ){
                  success
                  message
                  reference
                  quoteId
              }
            }`;
      graphqlRequestHandler('createFarmInputQuote', query, variables, headers)
        .then((response: ICreateQuoteResponse) => {
          if (response?.success) return resolve(response);
          else return reject(response.message);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiDownloadQuote(quoteId: number): Promise<string> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {quoteId};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($quoteId: ID!){
            farmRequestQuotationDocument(quotationId: $quoteId, download: true){
              success
              message
            }
          }`;
      graphqlRequestHandler(
        'farmRequestQuotationDocument',
        query,
        variables,
        headers,
      )
        .then((response: IGenericResponse) => {
          if (response?.success) return resolve(response?.message ?? '');
          else return reject(response.message);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiRequestInvoiceDocument(
  invoiceId: number,
): Promise<string> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {invoiceId};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($invoiceId: ID!){
            farmRequestInvoiceDocument(invoiceId: $invoiceId){
              success
              message
            }
          }`;
      graphqlRequestHandler(
        'farmRequestInvoiceDocument',
        query,
        variables,
        headers,
      )
        .then((response: IGenericResponse) => {
          if (response?.success) return resolve(response?.message ?? '');
          else return reject(response.message);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiDeleteQuote(quoteId: number): Promise<boolean> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {quoteId};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($quoteId: ID!){
            deleteQuote(quoteId: $quoteId){
              id
            }
          }`;
      graphqlRequestHandler('deleteQuote', query, variables, headers)
        .then(() => resolve(true))
        .catch((error) => reject(error));
    });
  });
}

export async function apiCheckoutQuote(
  user: ISupplierUserProfile,
  quote: IFarmInputQuote,
  logisticsTypeId: IlogisticsTypeId,
  isVatExempt: boolean,
  logisticsCost: number,
  specialInstructions?: {
    contactPersonName?: string;
    contactPersonPhoneNumber?: string;
    deliveryInstructions?: string;
  },
  paymentOptions?: {
    paymentType?: EInputOrderPaymentType;
    gpayAccountIdsByProductId?: Record<string, string | number>;
    gpayTransactional?: boolean;
  },
): Promise<ICreateInvoiceResponse> {
  console.log(paymentOptions);
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const isWalletPayment =
      paymentOptions?.paymentType === EInputOrderPaymentType.WALLET;
    const missingWalletProducts = isWalletPayment
      ? quote.lineItems.filter(
          (item) =>
            !paymentOptions?.gpayAccountIdsByProductId?.[
              String(item.product.id)
            ],
        )
      : [];
    if (missingWalletProducts.length) {
      return Promise.reject(
        new Error(
          'Wallet payment could not be processed for all products. ' +
            'Please check the approved cashflow budget and try again.',
        ),
      );
    }
    const products = quote.lineItems.map((item) => {
      const gpayAccountId =
        paymentOptions?.gpayAccountIdsByProductId?.[String(item.product.id)];
      return {
        id: String(item.product.id),
        stockCode: item.product.stockCode,
        price: item.price,
        quantity: item.quantity,
        logisticsType: logisticsTypeId,
        ...(gpayAccountId ? {gpayAccountId} : {}),
        gpayTransactional: paymentOptions?.gpayTransactional ?? false,
      };
    });
    const deliveryAddress: IInputQuoteAddress = {
      address: quote.address,
      deportId: Number(quote.depot.id),
      latitude: quote.latitude,
      longitude: quote.longitude,
    };
    const variables = {
      baskets: [
        {
          products,
          depotId: Number(quote.depot.id),
          quoteId: quote.id,
          logisticsCost,
        },
      ],
      deliveryAddress,
      paymentType:
        paymentOptions?.paymentType || EInputOrderPaymentType.INVOICE,
      quoteId: quote.id,
      farmerId: quote.farmer.id,
      vatExempted: isVatExempt,
      specialInstructions,
      useWallet: paymentOptions?.gpayTransactional ?? false,
    };
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $baskets:[buyInputBasket]!,
            $deliveryAddress:DeliveryAddressInput,
            $paymentType:ID,
            $quoteId:ID,
            $farmerId:ID,
            $vatExempted:Boolean,
            $specialInstructions:BuyInputsSpecialInstructions,
            $useWallet:Boolean,
          ){
              buyInputProducts(
                baskets:$baskets,
                deliveryAddress:$deliveryAddress,
                paymentType:$paymentType,
                quoteId:$quoteId,
                farmerId:$farmerId,
                vatExempted:$vatExempted,
                specialInstructions:$specialInstructions,
                useWallet:$useWallet,
              ){
                  success
                  message
                  references{
                    reference
                    invoice{
                      id
                    }

                  }
                  bundlerId
              }
          }`;
      graphqlRequestHandler('buyInputProducts', query, variables, headers)
        .then((response: any) => {
          if (response?.success)
            return resolve({
              ...response,
              reference: response.references[0].reference,
              invoiceId: response.references[0].invoice?.id ?? null,
              proformaInvoiceId: response.references[0].invoice?.id ?? null,
            });
          else return reject(response.message);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiSENDQUOTETEXTMESSAGE(
  quoteId: number,
  message: string,
): Promise<boolean> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {quotationIndex: quoteId, textMessage: message, mType: 1};
    return new Promise((resolve, reject) => {
      const query = `
        mutation variables($quotationIndex: ID!, $textMessage: String!, $mType: ID!){
            sendQuoteMessage(quotationIndex: $quotationIndex, textMessage: $textMessage, mType: $mType){
                id
            }
        }`;
      graphqlRequestHandler('sendQuoteMessage', query, variables, headers)
        .then((_: IQuoteMessage) => {
          resolve(true);
        })
        .catch((error) => reject(error));
    });
  });
}

export async function apiGETQUOTEMESSAGES(
  quoteId: number,
): Promise<IQuoteMessage[]> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {quotationIndex: quoteId};
    return new Promise((resolve, reject) => {
      const query = `
        query variables($quotationIndex: ID!){
            getQuoteMessages(quotationIndex: $quotationIndex){
                id
                quotationIndex
                mType
                sent
                sender
                textMessage
            }
        }`;
      graphqlRequestHandler('getQuoteMessages', query, variables, headers)
        .then((messages: any[]) => {
          const mappedMessages = messages.map((message) =>
            mapQuoteMessage(message),
          );
          resolve(mappedMessages);
        })
        .catch((error) => reject(error));
    });
  });
}

const mapQuoteMessage = (response: any): IQuoteMessage => {
  response.mType = parseInt(response.mType);
  const quoteMessage: IQuoteMessage = {
    id: response.id,
    quoteId: response.quotationId,
    messageType:
      response.mType === 1
        ? 'TEXT'
        : response.mType === 2
        ? 'IMAGE'
        : 'PRODUCT',
    message: response.textMessage,
    senderType: response.sender === 0 ? 'FARMER' : 'SUPPLIER',
    date: new Date(parseInt(response.sent)),
  };
  return quoteMessage;
};

export async function apiGetQuoteSupportingDocuments(
  quoteId: number | string,
): Promise<ISupportingDocument[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {quoteId};
    return new Promise((resolve, reject) => {
      const query = `
          query variables(
            $quoteId: ID!
          ){
            farmInputQuoteSupportingDocuments(
              quoteId: $quoteId
            ){
              id
              quoteId
              title
              url
              createdDate
            }
          }`;
      graphqlRequestHandler(
        'farmInputQuoteSupportingDocuments',
        query,
        variables,
        headers,
      )
        .then((response: ISupportingDocument[]) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiSaveQuoteSupportingDocument(
  input: IQuoteSupportingDocumentInput,
): Promise<ISupportingDocument> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {input};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $input: QuoteSupportingDocumentInput!
          ){
            farmInputQuoteSupportingDocumentSave(
              input: $input
            ){
              id
              quoteId
              title
              url
              createdDate
            }
          }`;
      graphqlRequestHandler(
        'farmInputQuoteSupportingDocumentSave',
        query,
        variables,
        headers,
      )
        .then((response: ISupportingDocument) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiDeleteQuoteSupportingDocument(
  documentId: number | string,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {id: documentId};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $id: ID!
          ){
            farmInputQuoteSupportingDocumentDelete(id: $id)
          }`;
      graphqlRequestHandler(
        'farmInputQuoteSupportingDocumentDelete',
        query,
        variables,
        headers,
      )
        .then(() => resolve({success: true}))
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetInvoiceSupportingDocuments(
  invoiceId: number | string,
): Promise<ISupportingDocument[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {invoiceId};
    return new Promise((resolve, reject) => {
      const query = `
          query variables(
            $invoiceId: ID!
          ){
            farmInputInvoiceSupportingDocuments(
              invoiceId: $invoiceId
            ){
              id
              invoiceId
              title
              url
              createdDate
            }
          }`;
      graphqlRequestHandler(
        'farmInputInvoiceSupportingDocuments',
        query,
        variables,
        headers,
      )
        .then((response: ISupportingDocument[]) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiSaveInvoiceSupportingDocument(
  input: IInvoiceSupportingDocumentInput,
): Promise<ISupportingDocument> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {input};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $input: InvoiceSupportingDocumentInput!
          ){
            farmInputInvoiceSupportingDocumentSave(
              input: $input
            ){
              id
              invoiceId
              title
              url
              createdDate
            }
          }`;
      graphqlRequestHandler(
        'farmInputInvoiceSupportingDocumentSave',
        query,
        variables,
        headers,
      )
        .then((response: ISupportingDocument) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiDeleteInvoiceSupportingDocument(
  documentId: number | string,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {id: documentId};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables(
            $id: ID!
          ){
            farmInputInvoiceSupportingDocumentDelete(id: $id)
          }`;
      graphqlRequestHandler(
        'farmInputInvoiceSupportingDocumentDelete',
        query,
        variables,
        headers,
      )
        .then(() => resolve({success: true}))
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetInvoiceBundles(
  limit?: number,
): Promise<IInvoiceBundle[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {limit};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($limit: Int){
              farmInputBundledInvoices(limit: $limit){
                  id
                  insertedOn
                  updatedOn
                  total
                  outstanding
                  allInvoicesPaid
                  invoices{
                      id
                      invoiceNumber
                      insertedDate
                      updatedDate
                      isPaid
                      latitude
                      longitude
                      address
                      total
                      outstanding
                      deliveryType
                      vatExempt
                      depot{
                          name
                          mainSupplier{
                              name
                          }
                      }
                      farmer{
                          id
                          name
                          surname
                          email
                          phone
                          image
                          address
                          farm{
                              id
                              name
                              sizeHectares
                              type
                              turnover
                              numberOfEmployees
                              province
                              latLong
                          }
                      }
                  }
              }
          }`;
      graphqlRequestHandler(
        'farmInputBundledInvoices',
        query,
        variables,
        headers,
      )
        .then((invoiceBundles: IInvoiceBundle[]) => {
          resolve(invoiceBundles);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiGetInvoiceBundle(id: number): Promise<IInvoiceBundle> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {id};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($id: ID){
              farmInputBundledInvoice(id: $id){
                  id
                  insertedOn
                  updatedOn
                  total
                  outstanding
                  allInvoicesPaid
                  invoices{
                      id
                      invoiceNumber
                      insertedDate
                      updatedDate
                      isPaid
                      latitude
                      longitude
                      address
                      total
                      outstanding
                      deliveryType
                      vatExempt
                      depot{
                          name
                          mainSupplier{
                              name
                          }
                      }
                      farmer{
                          id
                          name
                          surname
                          email
                          phone
                          image
                          address
                          farm{
                              id
                              name
                              sizeHectares
                              type
                              turnover
                              numberOfEmployees
                              province
                              latLong
                          }
                      }
                  }
              }
          }`;
      graphqlRequestHandler(
        'farmInputBundledInvoice',
        query,
        variables,
        headers,
      )
        .then((invoiceBundle: IInvoiceBundle) => {
          resolve(invoiceBundle);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiGetCreditNoteByInvoice(
  invoiceId: number | string,
): Promise<IFarmInputCreditNote | null> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {invoiceId};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($invoiceId: ID!){
              farmInputCreditNoteByInvoice(invoiceId: $invoiceId){
                  id
                  insertedDate
                  updatedDate
                  invoiceId
                  documentUrl
                  lineItems{
                    id
                    creditNoteId
                    orderId
                    quantity
                    price
                    order{
                      id
                      price
                      quantity
                      product{
                        name
                      }
                    }
                  }
              }
          }`;
      graphqlRequestHandler(
        'farmInputCreditNoteByInvoice',
        query,
        variables,
        headers,
      )
        .then((creditNote: IFarmInputCreditNote) => resolve(creditNote))
        .catch((error) => reject(error));
    });
  });
}

export async function apiUpdateCreditNote(
  invoiceId: number | string,
  lineItems: IFarmInputCreditNoteLineItemInput[],
): Promise<IFarmInputCreditNote> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {input: {invoiceId, lineItems}};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($input: FarmInputCreditNoteInput!){
              farmInputCreditNoteSave(input: $input){
                  id
                  insertedDate
                  updatedDate
                  invoiceId
                  lineItems{
                    id
                    creditNoteId
                    orderId
                    quantity
                    price
                    order{
                      id
                      price
                      quantity
                      product{
                        name
                      }
                    }
                  }
              }
          }`;
      graphqlRequestHandler(
        'farmInputCreditNoteSave',
        query,
        variables,
        headers,
      )
        .then((creditNote: IFarmInputCreditNote) => resolve(creditNote))
        .catch((error) => reject(error));
    });
  });
}

export async function apiDeleteCreditNoteLineItem(
  id: number | string,
): Promise<boolean> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {id};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($id: ID!){
              farmInputCreditNoteLineItemDelete(id: $id)
          }`;
      graphqlRequestHandler(
        'farmInputCreditNoteLineItemDelete',
        query,
        variables,
        headers,
      )
        .then((deleted: boolean) => resolve(deleted))
        .catch((error) => reject(error));
    });
  });
}

export async function apiUpdateCreditNoteLineItems(
  input: IFarmInputCreditNoteLineItemInput[],
): Promise<IFarmInputCreditNoteLineItem[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {input};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($input: [FarmInputCreditNoteLineItemInput!]!){
              farmInputCreditNoteLineItemSaveAll(input: $input){
                  id
                  creditNoteId
                  orderId
                  quantity
                  price
                  order{
                      id
                      price
                      quantity
                      product{
                          name
                      }
                  }
              }
          }`;
      graphqlRequestHandler(
        'farmInputCreditNoteLineItemSaveAll',
        query,
        variables,
        headers,
      )
        .then((lineItems: IFarmInputCreditNoteLineItem[]) => resolve(lineItems))
        .catch((error) => reject(error));
    });
  });
}

export async function apiGenerateCreditNotePdf(
  id: number | string,
): Promise<IFarmInputCreditNote> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {id};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($id: ID!){
              farmInputCreditNoteGeneratePdf(id: $id){
                  id
                  insertedDate
                  updatedDate
                  invoiceId
                  lineItems{
                    id
                    creditNoteId
                    orderId
                    quantity
                    price
                    order{
                      id
                      price
                      quantity
                      product{
                        name
                      }
                    }
                  }
              }
          }`;
      graphqlRequestHandler(
        'farmInputCreditNoteGeneratePdf',
        query,
        variables,
        headers,
      )
        .then((creditNote: IFarmInputCreditNote) => resolve(creditNote))
        .catch((error) => reject(error));
    });
  });
}
